export enum SeedOrigin {
  PURCHASED = "purchased",
  HARVESTED = "harvested",
  EXCHANGED = "exchanged",
  UNKNOWN = "unknown",
}
